import axios from 'axios';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { IContactResponse, ILeads, IPurlPinResponse } from './types';

export const requestActivatePIN = async (pin: string) => {
  const url = `/${SERVICES.LEAD}/purl/activate/${pin}`;
  try {
    const resp = await axios.get(url);
    Notistack.infoMessage('PURL PIN activated');
    return resp.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestAssignLeads = async (userId: string, data: ILeads[]) => {
  try {
    const groupedLeads: { [contactId: string]: string[] } = {};
    data.forEach((lead) => {
      if (Object.prototype.hasOwnProperty.call(groupedLeads, lead.contactId)) {
        groupedLeads[lead.contactId].push(lead.leadId);
      } else {
        groupedLeads[lead.contactId] = [lead.leadId];
      }
    });

    const payload = Object.entries(groupedLeads).map(([contactId, leadIds]) => ({
      contactId,
      leadIds,
    }));

    await axios.post(`${SERVICES.CONTACT}/assignUser/${userId}/bulk`, payload);
    Notistack.successMessage('Leads - Assigned Successfully \n Queues will be refresh in few seconds');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestNewLead = async (userId: string) => {
  const url = `/${SERVICES.LEAD}/dripfeederhistory/${userId}`;
  try {
    const resp = await axios.post<IContactResponse>(url);
    return resp.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestActivatePinUser = async (purlPinResponse: IPurlPinResponse) => {
  const url = `/${SERVICES.LEAD}/purl/activate/${purlPinResponse.purlPin}/user`;
  try {
    const resp = await axios.post(url, purlPinResponse);
    Notistack.infoMessage('PURL PIN activated');
    return resp.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestDeleteReminders = async (reminderId = '') => {
  const path = `${SERVICES.NOTIFICATION}/reminders`;
  try {
    await axios.delete(`${path}/${reminderId}`);
    Notistack.successMessage('Reminder - Deleted Successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestDeleteDealStatusReminders = async (reminderId = '') => {
  const path = `${SERVICES.NOTIFICATION}/deal-lender-status-notification`;
  try {
    await axios.delete(`${path}/${reminderId}`);
    Notistack.successMessage('Deal status reminder - Deleted Successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
